// extracted by mini-css-extract-plugin
export default {"filesContainer":"Files_filesContainer__Klc2m","topItems":"Files_topItems__6obGN","content":"Files_content__FEevC","files":"Files_files__aTEO9","removeBtn":"Files_removeBtn__CrETa"};